(function () {
  'use strict';

  // ── Config ──────────────────────────────────────────────────────────────────
  var API_URL          = '/apps/mockup/generate-custom-mockup';
  var CPC_VARIANTS_URL = '/products/custom-phone-case.js';
  var DEBOUNCE_MS      = 400;
  var PRINT_W = 1264, PRINT_H = 2244; // print area dimensions for client-side crop (px)


  // Exact copy from cas-options.js — prefix order matters for getBrand() matching
  var BRANDS = [
    { label: 'Apple',     prefix: 'iPhone'    },
    { label: 'Samsung',   prefix: 'Samsung'   },
    { label: 'Xiaomi',    prefix: 'Xiaomi'    },
    { label: 'Google',    prefix: 'Google'    },
    { label: 'OnePlus',   prefix: 'OnePlus'   },
    { label: 'Motorola',  prefix: 'Motorola'  },
    { label: 'Nothing',   prefix: 'Nothing'   },
    { label: 'Oppo',      prefix: 'Oppo'      },
    { label: 'Fairphone', prefix: 'Fairphone' },
    { label: 'Honor',     prefix: 'Honor'     },
  ];

  var GROUP_ORDER = [
    'Apple', 'Samsung', 'Xiaomi', 'Google', 'OnePlus', 'Motorola',
    'Nothing', 'Oppo', 'Fairphone', 'Honor',
  ];

  // ── Case type info (for compare modal) ──────────────────────────────────────
  var CASE_INFO = {
    'Snap Case': {
      img: 'https://cdn.shopify.com/s/files/1/0897/1327/9304/files/snap-case.png',
      pros: ['Ultra Slim', 'Lightweight', 'Glossy finish'],
      cons: ['Buttons and charging port are not protected'],
    },
    'Tough Case': {
      img: 'https://cdn.shopify.com/s/files/1/0897/1327/9304/files/tough-case.png',
      pros: ['Dual-layer protection', 'Buttons and charging port are protected', 'Raised bezels protect screen & camera', 'Glossy finish'],
      cons: ['Slightly bulkier than snap case'],
    },
    'Tough Case with MagSafe': {
      img: 'https://cdn.shopify.com/s/files/1/0897/1327/9304/files/tough-case-with-magsafe.png',
      pros: ['Dual-layer protection', 'Buttons and charging port are protected', 'Raised bezels protect screen & camera', 'Glossy finish', 'Built-in MagSafe ring for magnetic accessories'],
      cons: ['Slightly bulkier than snap case'],
    },
    'Wallet Case': {
      img: 'https://cdn.shopify.com/s/files/1/0897/1327/9304/files/wallet-case.png?v=1776346252',
      pros: ['3 storage slots', 'Case wraps around the phone ensuring full protection', 'Made from artificial leather', 'Matte finish'],
      cons: ['Slightly bulkier than snap case'],
    },
  };

  var CASE_TYPE_ORDER = ['Soft Case', 'Soft Case (Black)', 'Eco Case', 'Hard Case', 'Hard Case (Clear)', 'Snap Case', 'Tough Case', 'Tough Case with MagSafe', 'Hybrid Case with MagSafe', 'Wallet Case'];

  // Shopify variant name -> internal cases_by_device.json key (for CPC product name drift)
  var VARIANT_NAME_MAP = {
    'snap case':        'Hard Case',
    'snap case (clear)':'Hard Case (Clear)',
  };

  var CASE_DISPLAY_NAME = {
    'Snap Case':                'Snap',
    'Tough Case':               'Tough',
    'Tough Case with MagSafe':  'Tough MagSafe',
    'Wallet Case':              'Wallet',
    'Soft Case':                'Soft',
    'Soft Case (Black)':        'Soft Black',
    'Hard Case':                'Snap',
    'Hard Case (Clear)':        'Snap Clear',
    'Eco Case':                 'Eco',
    'Hybrid Case with MagSafe': 'Hybrid MagSafe',
  };

  var CASE_GROUPS = [
    { variants: ['Snap Case'] },
    { variants: ['Tough Case', 'Tough Case with MagSafe'], chips: ['Standard', 'MagSafe'] },
    { variants: ['Wallet Case'] },
  ];

  // ── Delivery data (per country, per tier: [min, max] workdays) ───────────────
  var DELIVERY_DATA = {
    'Austria':              { tracked: [2,4],   express: [2,4] },
    'Belgium':              { tracked: [2,4],   express: [1,1] },
    'Bulgaria':             {                   express: [2,4] },
    'Croatia':              {                   express: [2,4] },
    'Cyprus':               {                   express: [2,4] },
    'Czech Republic':       {                   express: [2,4] },
    'Czechia':              {                   express: [2,4] },
    'Denmark':              {                   express: [2,4] },
    'Estonia':              {                   express: [2,4] },
    'Finland':              {                   express: [2,4] },
    'France':               { tracked: [3,5],   express: [2,3] },
    'Germany':              { tracked: [2,4],   express: [2,3] },
    'Greece':               {                   express: [2,4] },
    'Hungary':              {                   express: [2,4] },
    'Ireland':              { tracked: [4,6],   express: [2,4] },
    'Italy':                { tracked: [5,7],   express: [2,4] },
    'Latvia':               {                   express: [2,4] },
    'Lithuania':            {                   express: [2,4] },
    'Luxembourg':           { tracked: [3,5],   express: [2,4] },
    'Malta':                {                   express: [2,4] },
    'Netherlands':          { tracked: [1,2],   express: [1,1] },
    'Poland':               {                   express: [2,4] },
    'Portugal':             {                   express: [2,4] },
    'Romania':              {                   express: [2,4] },
    'Slovakia':             {                   express: [2,4] },
    'Slovenia':             {                   express: [2,4] },
    'Spain':                { tracked: [5,7],   express: [2,4] },
    'Sweden':               { tracked: [4,6],   express: [2,4] },
    'Australia':            { tracked: [10,20], express: [4,6] },
    'Canada':               { tracked: [5,10],  express: [2,3] },
    'Kuwait':               {                   express: [4,7] },
    'Mexico':               {                   express: [4,7] },
    'Norway':               { tracked: [5,7],   express: [2,3] },
    'Qatar':                {                   express: [4,7] },
    'Saudi Arabia':         {                   express: [4,7] },
    'Switzerland':          { tracked: [3,5],   express: [1,2] },
    'United Arab Emirates': {                   express: [4,7] },
    'United Kingdom':       { tracked: [4,6],   express: [2,3] },
    'United States':        { tracked: [3,8],   express: [2,3] },
    '_uk_channel_islands':  { tracked: [4,6],   express: [2,3] },
    '_rest_of_eu':          { tracked: [5,10]                  },
    '_rest_of_world':       { tracked: [10,20], express: [4,7] },
  };

  var EU_COUNTRIES = [
    'Austria','Belgium','Bulgaria','Croatia','Cyprus','Czech Republic','Czechia',
    'Denmark','Estonia','Finland','France','Germany','Greece','Hungary','Ireland',
    'Italy','Latvia','Lithuania','Luxembourg','Malta','Netherlands','Poland',
    'Portugal','Romania','Slovakia','Slovenia','Spain','Sweden'
  ];

  var UK_CHANNEL_ISLANDS = ['Jersey','Guernsey','Isle of Man'];

  // ── State ───────────────────────────────────────────────────────────────────
  var caseData          = {};
  var modelsByBrand     = {};
  var cpcVariants       = null;  // null = not yet fetched
  var variantPriceByCase = {};   // case type => lowest price in cents
  var basePrice         = null;  // cheapest variant price
  var caseTypeOrder     = CASE_TYPE_ORDER.slice(); // overridden from API variant order
  var moneyFormat       = '\u20ac{{amount}}'; // overridden from section data attr
  var activeBrand       = null;

  var selectedModel  = null;
  var selectedCase   = null;
  var uploadedBase64  = null;
  var upscaledBase64  = null; // upscaled PNG returned by server on first generation
  var uploadedUrl     = null;
  var mockupReady    = false;
  var isGenerating   = false;
  var atcBusy        = false;
  var crossFadeLoop  = null;
  var genTimer       = null;
  var _ccStockCache  = {};
  var _ccStockLocked = false;
  var elStock        = null;

  // Reposition UI state
  var elRepoBtn           = null;
  var elRetryBtn          = null;
  var elLightbox          = null;
  var elLightboxImg       = null;
  var repoOffsetX         = 0;
  var repoOffsetY         = 0;
  var repoCoverScale      = 1;
  var repoFrameW          = 0;
  var repoFrameH          = 0;
  var repoDragging        = false;
  var repoDragStartX      = 0;
  var repoDragStartY      = 0;
  var repoOnConfirm       = null;
  var originalUploadedUrl = null; // Tigris URL of the first upload (pre-crop); set once per file
  var repoPersistOffsetX  = null; // remembered offset from last session (null = not set)
  var repoPersistOffsetY  = null;
  var repoFileVersion     = 0;    // increments on new file upload so saved offsets are invalidated
  var repoPersistVersion  = -1;   // file version when offsets were last saved

  // DOM refs (scoped to section root)
  var root, elModelBtn, elModelText, elCaseSel, elCaseBtns, elUploadZone, elFileInput, elUploadSub,
      elSteps, elAtcBtn, elFrameMockup, elFrameUpload, elFrameSpinner, elPhoneFrame, elMsg, elUpscaleBadge;

  // Model picker overlay refs (appended to body)
  var elPickerOverlay, elPickerList, elPickerSearch, elPickerBrandTabs,
      elPickerScrollLeft, elPickerScrollRight;

  // ── Helpers ─────────────────────────────────────────────────────────────────

  function norm(s) {
    return String(s).toLowerCase().replace(/-/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function isoToFlag(iso) {
    return '<img class="cc-delivery-flag-img" src="https://flagcdn.com/16x12/' + iso.toLowerCase() + '.png" width="16" height="12" alt="' + iso + '" loading="lazy">';
  }

  function fmtRange(arr) {
    return arr[0] === arr[1] ? String(arr[0]) : arr[0] + '\u2013' + arr[1];
  }

  function resolveDeliveryTiers(countryName) {
    if (UK_CHANNEL_ISLANDS.indexOf(countryName) !== -1) {
      return DELIVERY_DATA['_uk_channel_islands'];
    }
    var isEU = EU_COUNTRIES.indexOf(countryName) !== -1;
    var direct = DELIVERY_DATA[countryName] || null;
    if (isEU) {
      // Merge _rest_of_eu fallback for tiers the country doesn't have individually
      var base = DELIVERY_DATA['_rest_of_eu'] || {};
      return Object.assign({}, base, direct || {});
    }
    return direct || DELIVERY_DATA['_rest_of_world'] || {};
  }

  function buildDelivery(el, iso, name) {
    var flag  = iso.length === 2 ? '<span class="cc-delivery-flag">' + isoToFlag(iso) + '</span>' : '';
    var tiers = resolveDeliveryTiers(name);
    var chips = [];
    if (tiers.express) chips.push('<span class="cc-tier-chip cc-tier-chip--express">Express\u00a0' + fmtRange(tiers.express) + '</span>');
    if (tiers.tracked) chips.push('<span class="cc-tier-chip">Tracked\u00a0' + fmtRange(tiers.tracked) + '</span>');
    if (!chips.length) return;
    var TRUCK = '<svg class="cc-delivery-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
    el.innerHTML = TRUCK + '<div class="cc-tier-chips">' + chips.join('') + '</div>' + flag
      + '<span class="cc-delivery-caption">Delivery estimates in business days</span>';
    el.style.display = 'flex';
  }

  function buildFreeShipping(el) {
    var scriptTag = document.querySelector('script[src*="caselier-custom-cta.js"]');
    var price = (scriptTag && scriptTag.getAttribute('data-freeship-price')) || '\u20ac50';
    var text = 'Free shipping from\u00a0' + price;
    var GIFT = '<svg class="cc-freeship-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true"><path d="M20 12v10H4V12"/><path d="M22 7H2v5h20V7z"/><path d="M12 22V7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';
    el.innerHTML = '<div class="cc-freeship-line">' + GIFT + '<span class="cc-freeship-text">' + text + '</span></div>';
  }

  function formatMoney(cents) {
    var rounded = String(Math.round(cents / 100));
    var noDecFormat = moneyFormat
      .replace('{{amount}}', '{{amount_no_decimals}}')
      .replace('{{amount_with_comma_separator}}', '{{amount_no_decimals}}');
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, noDecFormat);
    }
    return noDecFormat
      .replace('{{amount_no_decimals}}', rounded)
      .replace('{{amount_no_decimals_with_comma_separator}}', rounded);
  }

  function getBrand(model) {
    for (var i = 0; i < BRANDS.length; i++) {
      if (model.indexOf(BRANDS[i].prefix) === 0) return BRANDS[i].label;
    }
    return 'Other';
  }

  // Exact copy from cas-options.js — higher score = shown first (newer/flagship)
  function modelSortScore(model) {
    var lower = model.toLowerCase();
    var score = 0;

    if (lower.indexOf('samsung') === 0) {
      var sm = model.match(/Galaxy\s+([A-Z])/);
      var series = sm ? sm[1] : 'X';
      if      (series === 'S') score += 20000;
      else if (series === 'Z') score += 18000;
      else if (series === 'A') score +=  5000;
      else                     score +=  8000;
    } else if (lower.indexOf('xiaomi') === 0) {
      if      (lower.indexOf('poco f')     !== -1) score += 12000;
      else if (lower.indexOf('poco x')     !== -1) score += 10000;
      else if (lower.indexOf('poco m')     !== -1) score +=  8000;
      else if (lower.indexOf('poco')       !== -1) score +=  9000;
      else if (lower.indexOf('redmi note') !== -1) score +=  4000;
      else if (lower.indexOf('redmi')      !== -1) score +=  2000;
      else                                         score += 15000;
    } else if (lower.indexOf('oneplus') === 0) {
      if      (lower.indexOf('nord ce') !== -1) score +=  1000;
      else if (lower.indexOf('nord')    !== -1) score +=  3000;
      else                                      score += 15000;
    } else if (lower.indexOf('motorola') === 0) {
      if      (lower.indexOf('thinkphone') !== -1) score +=     0;
      else if (lower.indexOf('edge')       !== -1) score += 20000;
      else if (lower.indexOf('moto g')     !== -1) score +=  5000;
      else                                         score +=  8000;
    } else {
      score += 15000;
    }

    var nums = model.match(/\d+/g);
    if (nums && nums.length > 0) {
      var n = parseInt(nums[0], 10);
      score += (n >= 2020 && n <= 2035 ? 100 : n) * 100;
    } else if (lower.indexOf(' x') !== -1) {
      score += 1000;
    } else if (lower.indexOf('air') !== -1) {
      score += 1650;
    }

    if (lower.indexOf('ultra') !== -1)                                       score += 50;
    if (lower.indexOf('pro max') !== -1)                                     score += 35;
    else if (lower.indexOf('pro plus') !== -1)                               score += 33;
    else if (lower.indexOf('pro') !== -1)                                    score += 30;
    if (lower.indexOf(' xl') !== -1)                                         score += 10;
    if (lower.indexOf(' plus') !== -1 && lower.indexOf('pro') === -1)       score += 20;
    if (/\d+e\b/i.test(model))                                               score -= 10;
    if (/\d+r\b/i.test(model))                                               score -=  8;
    if (/\d+a\b/i.test(model) && lower.indexOf('air') === -1)               score -=  5;
    if (lower.indexOf(' fe ') !== -1 || /\bfe$/i.test(model))               score -= 10;
    if (lower.indexOf(' lite') !== -1)                                       score -= 15;
    if (lower.indexOf(' power') !== -1)                                      score -= 15;
    if (lower.indexOf(' mini') !== -1)                                       score -= 12;

    return score;
  }

  // ── Galaxy WebGL ─────────────────────────────────────────────────────────────

  var GALAXY_VERT = [
    'attribute vec2 uv;',
    'attribute vec2 position;',
    'varying vec2 vUv;',
    'void main(){vUv=uv;gl_Position=vec4(position,0,1);}'
  ].join('\n');

  var GALAXY_FRAG = [
    'precision highp float;',
    'uniform float uTime;',
    'uniform vec3 uResolution;',
    'uniform vec2 uFocal;',
    'uniform vec2 uRotation;',
    'uniform float uStarSpeed;',
    'uniform float uDensity;',
    'uniform float uHueShift;',
    'uniform float uSpeed;',
    'uniform vec2 uMouse;',
    'uniform float uGlowIntensity;',
    'uniform float uSaturation;',
    'uniform bool uMouseRepulsion;',
    'uniform float uTwinkleIntensity;',
    'uniform float uRotationSpeed;',
    'uniform float uRepulsionStrength;',
    'uniform float uMouseActiveFactor;',
    'uniform float uAutoCenterRepulsion;',
    'uniform bool uTransparent;',
    'varying vec2 vUv;',
    '#define NUM_LAYER 4.0',
    '#define STAR_COLOR_CUTOFF 0.2',
    '#define MAT45 mat2(0.7071,-0.7071,0.7071,0.7071)',
    '#define PERIOD 3.0',
    'float Hash21(vec2 p){p=fract(p*vec2(123.34,456.21));p+=dot(p,p+45.32);return fract(p.x*p.y);}',
    'float tri(float x){return abs(fract(x)*2.0-1.0);}',
    'float tris(float x){float t=fract(x);return 1.0-smoothstep(0.0,1.0,abs(2.0*t-1.0));}',
    'float trisn(float x){float t=fract(x);return 2.0*(1.0-smoothstep(0.0,1.0,abs(2.0*t-1.0)))-1.0;}',
    'vec3 hsv2rgb(vec3 c){vec4 K=vec4(1.0,2.0/3.0,1.0/3.0,3.0);vec3 p=abs(fract(c.xxx+K.xyz)*6.0-K.www);return c.z*mix(K.xxx,clamp(p-K.xxx,0.0,1.0),c.y);}',
    'float Star(vec2 uv,float flare){',
    '  float d=length(uv);float m=(0.05*uGlowIntensity)/d;',
    '  float rays=smoothstep(0.0,1.0,1.0-abs(uv.x*uv.y*1000.0));',
    '  m+=rays*flare*uGlowIntensity;uv*=MAT45;',
    '  rays=smoothstep(0.0,1.0,1.0-abs(uv.x*uv.y*1000.0));',
    '  m+=rays*0.3*flare*uGlowIntensity;m*=smoothstep(1.0,0.2,d);return m;',
    '}',
    'vec3 StarLayer(vec2 uv){',
    '  vec3 col=vec3(0.0);vec2 gv=fract(uv)-0.5;vec2 id=floor(uv);',
    '  for(int y=-1;y<=1;y++){for(int x=-1;x<=1;x++){',
    '    vec2 si=id+vec2(float(x),float(y));',
    '    float seed=Hash21(si);float size=fract(seed*345.32);',
    '    float glossLocal=tri(uStarSpeed/(PERIOD*seed+1.0));',
    '    float flareSize=smoothstep(0.9,1.0,size)*glossLocal;',
    '    float red=smoothstep(STAR_COLOR_CUTOFF,1.0,Hash21(si+1.0))+STAR_COLOR_CUTOFF;',
    '    float blu=smoothstep(STAR_COLOR_CUTOFF,1.0,Hash21(si+3.0))+STAR_COLOR_CUTOFF;',
    '    float grn=min(red,blu)*seed;vec3 base=vec3(red,grn,blu);',
    '    float hue=atan(base.g-base.r,base.b-base.r)/(2.0*3.14159)+0.5;',
    '    hue=fract(hue+uHueShift/360.0);',
    '    float sat=length(base-vec3(dot(base,vec3(0.299,0.587,0.114))))*uSaturation;',
    '    float val=max(max(base.r,base.g),base.b);base=hsv2rgb(vec3(hue,sat,val));',
    '    vec2 pad=vec2(tris(seed*34.0+uTime*uSpeed/10.0),tris(seed*38.0+uTime*uSpeed/30.0))-0.5;',
    '    float star=Star(gv-vec2(float(x),float(y))-pad,flareSize);',
    '    float twinkle=trisn(uTime*uSpeed+seed*6.2831)*0.5+1.0;',
    '    twinkle=mix(1.0,twinkle,uTwinkleIntensity);col+=star*size*base*twinkle;',
    '  }}return col;',
    '}',
    'void main(){',
    '  vec2 focalPx=uFocal*uResolution.xy;',
    '  vec2 uv=(vUv*uResolution.xy-focalPx)/uResolution.y;',
    '  if(uAutoCenterRepulsion>0.0){',
    '    float d=length(uv);vec2 r=normalize(uv)*(uAutoCenterRepulsion/(d+0.1));uv+=r*0.05;',
    '  } else if(uMouseRepulsion){',
    '    vec2 mp=(uMouse*uResolution.xy-focalPx)/uResolution.y;',
    '    float md=length(uv-mp);vec2 r=normalize(uv-mp)*(uRepulsionStrength/(md+0.1));',
    '    uv+=r*0.05*uMouseActiveFactor;',
    '  } else { uv+=(uMouse-vec2(0.5))*0.1*uMouseActiveFactor; }',
    '  float a=uTime*uRotationSpeed;',
    '  uv=mat2(cos(a),-sin(a),sin(a),cos(a))*uv;',
    '  uv=mat2(uRotation.x,-uRotation.y,uRotation.y,uRotation.x)*uv;',
    '  vec3 col=vec3(0.0);',
    '  for(float i=0.0;i<1.0;i+=1.0/NUM_LAYER){',
    '    float depth=fract(i+uStarSpeed*uSpeed);',
    '    float scale=mix(20.0*uDensity,0.5*uDensity,depth);',
    '    float fade=depth*smoothstep(1.0,0.9,depth);',
    '    col+=StarLayer(uv*scale+i*453.32)*fade;',
    '  }',
    '  if(uTransparent){float alpha=min(smoothstep(0.0,0.3,length(col)),1.0);gl_FragColor=vec4(col,alpha);}',
    '  else{gl_FragColor=vec4(col,1.0);}',
    '}'
  ].join('\n');

  function loadOGL(cb) {
    if (window.ogl || window.OGL) { cb(); return; }
    var s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/ogl@1.0.8/dist/ogl.umd.js';
    s.onload = cb;
    s.onerror = function () { console.warn('[cc-galaxy] OGL failed to load'); };
    document.head.appendChild(s);
  }

  function initGalaxy(mount) {
    var OGL = window.ogl || window.OGL;
    if (!OGL) { console.warn('[cc-galaxy] OGL not found'); return; }

    var renderer = new OGL.Renderer({ alpha: true, premultipliedAlpha: false });
    var gl = renderer.gl;
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
    gl.clearColor(0, 0, 0, 0);

    var prog;
    function resize() {
      renderer.setSize(mount.offsetWidth, mount.offsetHeight);
      if (prog) {
        prog.uniforms.uResolution.value = new OGL.Color(
          gl.canvas.width, gl.canvas.height, gl.canvas.width / gl.canvas.height
        );
      }
    }
    window.addEventListener('resize', resize);

    var geometry = new OGL.Triangle(gl);
    prog = new OGL.Program(gl, {
      vertex: GALAXY_VERT,
      fragment: GALAXY_FRAG,
      uniforms: {
        uTime:                { value: 0 },
        uResolution:          { value: new OGL.Color(1, 1, 1) },
        uFocal:               { value: new Float32Array([0.5, 0.5]) },
        uRotation:            { value: new Float32Array([1.0, 0.0]) },
        uStarSpeed:           { value: 0.0 },
        uDensity:             { value: 1.0 },
        uHueShift:            { value: 140.0 },
        uSpeed:               { value: 1.0 },
        uMouse:               { value: new Float32Array([0.5, 0.5]) },
        uGlowIntensity:       { value: 0.3 },
        uSaturation:          { value: 0.0 },
        uMouseRepulsion:      { value: true },
        uTwinkleIntensity:    { value: 0.3 },
        uRotationSpeed:       { value: 0.1 },
        uRepulsionStrength:   { value: 2.0 },
        uMouseActiveFactor:   { value: 0.0 },
        uAutoCenterRepulsion: { value: 0.0 },
        uTransparent:         { value: true },
      }
    });
    resize();

    var mesh = new OGL.Mesh(gl, { geometry: geometry, program: prog });
    var animId;
    var starSpd  = 0.5;
    var tMouse   = { x: 0.5, y: 0.5 };
    var sMouse   = { x: 0.5, y: 0.5 };
    var tActive  = 0;
    var sActive  = 0;

    function update(t) {
      animId = requestAnimationFrame(update);
      prog.uniforms.uTime.value      = t * 0.001;
      prog.uniforms.uStarSpeed.value = (t * 0.001 * starSpd) / 10.0;
      var lf = 0.05;
      sMouse.x += (tMouse.x - sMouse.x) * lf;
      sMouse.y += (tMouse.y - sMouse.y) * lf;
      sActive  += (tActive  - sActive)  * lf;
      prog.uniforms.uMouse.value[0]          = sMouse.x;
      prog.uniforms.uMouse.value[1]          = sMouse.y;
      prog.uniforms.uMouseActiveFactor.value = sActive;
      renderer.render({ scene: mesh });
    }
    animId = requestAnimationFrame(update);
    mount.appendChild(gl.canvas);

    mount.addEventListener('mousemove', function (e) {
      var r  = mount.getBoundingClientRect();
      tMouse.x = (e.clientX - r.left) / r.width;
      tMouse.y = 1.0 - (e.clientY - r.top) / r.height;
      tActive  = 1.0;
    });
    mount.addEventListener('mouseleave', function () { tActive = 0.0; });
  }

  // ── Boot ────────────────────────────────────────────────────────────────────

  function start() {
    var scriptTag = document.querySelector('script[src*="caselier-custom-cta"]');
    if (!scriptTag) return;

    root = scriptTag.closest('section.cc-root');
    // Script is outside </section> in liquid — search within the Shopify section wrapper
    if (!root) {
      var wrapper = scriptTag.parentElement;
      root = wrapper && wrapper.querySelector('section.cc-root');
    }
    if (!root) return;

    elModelBtn     = root.querySelector('#cc-model-btn');
    elModelText    = root.querySelector('#cc-model-text');
    elCaseSel      = root.querySelector('#cc-case-select');
    elCaseBtns     = root.querySelector('#cc-case-btns');
    elUploadZone   = root.querySelector('#cc-upload-zone');
    elFileInput    = root.querySelector('#cc-file-input');
    elUploadSub    = root.querySelector('#cc-upload-sub');
    elSteps        = root.querySelector('#cc-steps');
    elAtcBtn       = root.querySelector('#cc-atc-btn');
    elPhoneFrame   = root.querySelector('#cc-phone-frame');
    elFrameMockup  = root.querySelector('#cc-frame-mockup');
    elFrameUpload  = root.querySelector('#cc-frame-upload');
    elFrameSpinner = root.querySelector('#cc-frame-spinner');
    elMsg          = root.querySelector('#cc-msg');
    elUpscaleBadge = root.querySelector('#cc-upscale-badge');

    if (!elModelBtn) return;

    // Inject stock indicator just above the ATC button
    if (elAtcBtn) {
      var stockDiv = document.createElement('div');
      stockDiv.id = 'cc-stock';
      stockDiv.className = 'cc-stock';
      stockDiv.hidden = true;
      elAtcBtn.insertAdjacentElement('beforebegin', stockDiv);
      elStock = stockDiv;
    }

    // Read money format from inline script — strip HTML tags (Shopify often wraps in <span class="money">)
    if (window.ccMoneyFormat) moneyFormat = window.ccMoneyFormat.replace(/<[^>]+>/g, '');

    // Create "Reposition image" button, appended to .cc-right (outside all overflow:hidden containers)
    var elRight = root.querySelector('.cc-right');
    if (elRight) {
      elRepoBtn = document.createElement('button');
      elRepoBtn.type = 'button';
      elRepoBtn.id = 'cc-repo-btn';
      elRepoBtn.textContent = 'Reposition image';
      elRepoBtn.style.display = 'none';
      elRight.appendChild(elRepoBtn);
      elRepoBtn.addEventListener('click', function() {
        var cropSrc = upscaledBase64
          ? 'data:image/png;base64,' + upscaledBase64
          : 'data:' + base64MimeType(uploadedBase64) + ';base64,' + uploadedBase64;
        openRepositionUI(cropSrc, function(ox, oy) {
          cropToBase64(cropSrc, uploadedBase64, ox, oy).then(function(croppedBase64) {
            doGenerate(croppedBase64);
          });
        });
      });

      elRetryBtn = document.createElement('button');
      elRetryBtn.type = 'button';
      elRetryBtn.id = 'cc-retry-btn';
      elRetryBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>Try again';
      elRetryBtn.style.display = 'none';
      elRight.appendChild(elRetryBtn);
      elRetryBtn.addEventListener('click', function() {
        elRetryBtn.style.display = 'none';
        doGenerate();
      });
    }

    // Lightbox — appended to body so it overlays everything
    elLightbox = document.createElement('div');
    elLightbox.id = 'cc-lightbox';
    elLightboxImg = document.createElement('img');
    elLightboxImg.alt = '';
    elLightbox.appendChild(elLightboxImg);
    document.body.appendChild(elLightbox);
    elLightbox.addEventListener('click', closeLightbox);

    // Zoom hint icon inside phone frame
    if (elPhoneFrame) {
      var elZoomHint = document.createElement('div');
      elZoomHint.className = 'cc-frame-zoom-hint';
      elZoomHint.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>';
      elPhoneFrame.appendChild(elZoomHint);
      elPhoneFrame.addEventListener('click', function() {
        if (!elPhoneFrame.classList.contains('cc-phone-frame--zoomable')) return;
        openLightbox();
      });
    }

    var casesJsonUrl = scriptTag.dataset.casJson || '';
    boot(casesJsonUrl);

    // Free shipping line
    var elFreeship = root.querySelector('#cc-freeship');
    if (elFreeship) buildFreeShipping(elFreeship);

    // Build per-country delivery estimate
    var elDelivery = root.querySelector('.cc-delivery');
    if (elDelivery) {
      var iso  = elDelivery.dataset.countryIso  || '';
      var name = elDelivery.dataset.countryName || '';
      if (iso.length === 2 && name) buildDelivery(elDelivery, iso, name);
    }

    // Galaxy background
    var galaxyMount = root.querySelector('#cc-galaxy-mount');
    if (galaxyMount) {
      loadOGL(function () { initGalaxy(galaxyMount); });
    }
  }

  function boot(casesJsonUrl) {
    fetch(casesJsonUrl)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        caseData = data;
        buildModelIndex();
        buildPickerPanel();
        attachListeners();
        buildModals();
        fetchVariants();
        // Restore last model selected anywhere on the site (shared key with product page)
        try {
          var _m = localStorage.getItem('cas_model');
          if (_m) {
            var _exists = Object.keys(modelsByBrand).some(function(b) {
              return modelsByBrand[b].indexOf(_m) !== -1;
            });
            if (_exists) selectPickerModel(_m);
          }
        } catch (e) {}
      })
      .catch(function (err) {
        console.error('[CTA] Failed to load cases_by_device.json', err);
      });
  }

  // ── Model index ─────────────────────────────────────────────────────────────

  function buildModelIndex() {
    var seen = {};
    Object.keys(caseData).forEach(function (ct) {
      if (ct.charAt(0) === '_') return;
      Object.keys(caseData[ct]).forEach(function (m) { seen[m] = true; });
    });
    modelsByBrand = {};
    Object.keys(seen).forEach(function (m) {
      var b = getBrand(m);
      if (!modelsByBrand[b]) modelsByBrand[b] = [];
      modelsByBrand[b].push(m);
    });
    Object.keys(modelsByBrand).forEach(function (b) {
      modelsByBrand[b].sort(function (a, z) {
        return modelSortScore(z) - modelSortScore(a);
      });
    });
  }

  // ── Model picker panel ──────────────────────────────────────────────────────

  function buildPickerBrandTabsHTML() {
    var seen = {};
    var html = '';
    BRANDS.forEach(function (b) {
      var tab = b.label;
      if (seen[tab]) return;
      if (!modelsByBrand[tab] || !modelsByBrand[tab].length) return;
      seen[tab] = true;
      html += '<button class="cc-brand-tab" data-brand="' + esc(tab) + '">' + esc(tab) + '</button>';
    });
    return html;
  }

  function buildPickerPanel() {
    var SEARCH_ICON = '<svg class="cc-search-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>';
    var CHEV_LEFT  = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>';
    var CHEV_RIGHT = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';

    var el = document.createElement('div');
    el.innerHTML =
      '<div class="cc-picker-overlay" id="cc-picker-overlay" role="dialog" aria-modal="true" aria-label="Select your model">' +
        '<div class="cc-picker-panel">' +
          '<div class="cc-picker-top">' +
            '<div class="cc-drag-handle"></div>' +
            '<p class="cc-picker-title">Select your model</p>' +
            '<div class="cc-search-wrap">' +
              SEARCH_ICON +
              '<input type="text" id="cc-picker-search" class="cc-search-input" placeholder="Search models\u2026" autocomplete="off" autocorrect="off" spellcheck="false">' +
            '</div>' +
            '<div class="cc-brand-scroll-wrap">' +
              '<button class="cc-scroll-btn cc-scroll-btn--left cc-scroll-btn--hidden" id="cc-scroll-left" aria-label="Scroll left">' + CHEV_LEFT + '</button>' +
              '<div class="cc-brand-tabs" id="cc-brand-tabs">' + buildPickerBrandTabsHTML() + '</div>' +
              '<button class="cc-scroll-btn cc-scroll-btn--right" id="cc-scroll-right" aria-label="Scroll right">' + CHEV_RIGHT + '</button>' +
            '</div>' +
          '</div>' +
          '<div class="cc-picker-list" id="cc-picker-list"></div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el.firstElementChild);

    elPickerOverlay    = document.getElementById('cc-picker-overlay');
    elPickerList       = document.getElementById('cc-picker-list');
    elPickerSearch     = document.getElementById('cc-picker-search');
    elPickerBrandTabs  = document.getElementById('cc-brand-tabs');
    elPickerScrollLeft  = document.getElementById('cc-scroll-left');
    elPickerScrollRight = document.getElementById('cc-scroll-right');

    // Listeners for the picker itself
    elPickerOverlay.addEventListener('click', function (e) {
      if (e.target === elPickerOverlay) closePickerPanel();
    });
    elPickerSearch.addEventListener('input', function () {
      renderPickerList();
    });
    elPickerBrandTabs.addEventListener('click', function (e) {
      var btn = e.target.closest('.cc-brand-tab');
      if (!btn) return;
      activeBrand = btn.dataset.brand === activeBrand ? null : btn.dataset.brand;
      updatePickerBrandTabs();
      elPickerSearch.value = '';
      renderPickerList();
    });
    elPickerBrandTabs.addEventListener('scroll', updateScrollBtns);
    elPickerScrollLeft.addEventListener('click', function () {
      elPickerBrandTabs.scrollLeft = 0;
      updateScrollBtns();
    });
    elPickerScrollRight.addEventListener('click', function () {
      elPickerBrandTabs.scrollLeft = elPickerBrandTabs.scrollWidth;
      updateScrollBtns();
    });
  }

  function renderPickerList() {
    var q    = elPickerSearch.value.toLowerCase().trim();
    var html = '';
    var count = 0;

    var labels = GROUP_ORDER.filter(function (label) {
      if (!modelsByBrand[label] || !modelsByBrand[label].length) return false;
      if (activeBrand && label !== activeBrand) return false;
      return true;
    });
    if (modelsByBrand['Other'] && modelsByBrand['Other'].length) labels.push('Other');

    labels.forEach(function (label) {
      var models = modelsByBrand[label].filter(function (m) {
        return !q || m.toLowerCase().indexOf(q) !== -1;
      });
      if (!models.length) return;
      html += '<div class="cc-picker-group">';
      html += '<div class="cc-picker-brand-header">' + esc(label) + '</div>';
      models.forEach(function (m) {
        var sel = m === selectedModel;
        html += '<div class="cc-picker-item' + (sel ? ' cc-picker-item--selected' : '') + '" data-model="' + esc(m) + '" role="option" aria-selected="' + sel + '">';
        html += '<span>' + esc(m) + '</span>';
        if (sel) html += '<svg class="cc-picker-check" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';
        html += '</div>';
        count++;
      });
      html += '</div>';
    });

    if (!count) {
      html = '<p class="cc-picker-empty">No models found' + (q ? ' for \u201c' + esc(q) + '\u201d' : '') + '</p>';
    }

    elPickerList.innerHTML = html;
    elPickerList.querySelectorAll('.cc-picker-item').forEach(function (el) {
      el.addEventListener('click', function () {
        selectPickerModel(el.dataset.model);
        closePickerPanel();
      });
    });
  }

  function openPickerPanel() {
    activeBrand = null;
    elPickerSearch.value = '';
    elPickerBrandTabs.querySelectorAll('.cc-brand-tab').forEach(function (btn) {
      btn.classList.remove('cc-brand-tab--active');
    });
    renderPickerList();
    elPickerOverlay.classList.add('cc-picker-overlay--open');
    document.body.style.overflow = 'hidden';
    // updateScrollBtns must run after the panel is visible (scrollWidth is 0 while display:none)
    requestAnimationFrame(function () {
      updateScrollBtns();
      var sel = elPickerList.querySelector('.cc-picker-item--selected');
      if (sel) sel.scrollIntoView({ block: 'center' });
      if (!window.matchMedia('(hover: none)').matches) elPickerSearch.focus();
    });
  }

  function closePickerPanel() {
    elPickerOverlay.classList.remove('cc-picker-overlay--open');
    document.body.style.overflow = '';
    elModelBtn.focus();
  }

  function selectPickerModel(model) {
    selectedModel = model;
    try { localStorage.setItem('cas_model', model); } catch (e) {}
    elModelText.textContent = model;
    elModelText.classList.remove('cc-placeholder');
    selectedCase = null;
    elCaseSel.value = '';
    buildCaseButtons(selectedModel);
    resetMockup();
    updateSteps();
    fetchStock();
    maybeGenerate();
  }

  function updatePickerBrandTabs() {
    elPickerBrandTabs.querySelectorAll('.cc-brand-tab').forEach(function (btn) {
      btn.classList.toggle('cc-brand-tab--active', btn.dataset.brand === activeBrand);
    });
    updateScrollBtns();
  }

  function updateScrollBtns() {
    var atStart = elPickerBrandTabs.scrollLeft <= 2;
    var atEnd   = elPickerBrandTabs.scrollLeft >= elPickerBrandTabs.scrollWidth - elPickerBrandTabs.clientWidth - 2;
    elPickerScrollLeft.classList.toggle('cc-scroll-btn--hidden', atStart);
    elPickerScrollRight.classList.toggle('cc-scroll-btn--hidden', atEnd);
  }

  function buildCaseButtons(model) {
    elCaseSel.innerHTML = '';
    if (!elCaseBtns) return;
    if (!model) {
      elCaseBtns.innerHTML = '<p class="cc-type-placeholder">Select a model first</p>';
      return;
    }
    var available = Object.keys(caseData).filter(function (ct) {
      return ct.charAt(0) !== '_' && Object.prototype.hasOwnProperty.call(caseData[ct], model);
    });
    if (!available.length) {
      elCaseBtns.innerHTML = '<p class="cc-type-placeholder">No cases available for this model</p>';
      return;
    }
    // Sort by caseTypeOrder (Shopify admin order); types not in the list go last
    available.sort(function (a, b) {
      var ia = caseTypeOrder.indexOf(a); if (ia === -1) ia = 9999;
      var ib = caseTypeOrder.indexOf(b); if (ib === -1) ib = 9999;
      return ia - ib;
    });
    elCaseBtns.innerHTML = '';
    available.forEach(function (ct) {
      // Keep hidden select populated for existing change-event listeners
      var opt = document.createElement('option');
      opt.value = ct;
      elCaseSel.appendChild(opt);

      var info = CASE_INFO[ct] || {};
      var displayName = CASE_DISPLAY_NAME[ct] || ct;
      var priceStr = variantPriceByCase[ct] !== undefined ? formatMoney(variantPriceByCase[ct]) : '';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cc-type-btn' + (selectedCase === ct ? ' cc-type-btn--active' : '');
      btn.dataset.case = ct;
      btn.innerHTML =
        '<div class="cc-type-btn-img-wrap">' +
          (info.img ? '<img class="cc-type-btn-img" src="' + info.img + '" alt="" loading="lazy">' : '') +
        '</div>' +
        '<span class="cc-type-btn-name">' + esc(displayName) + '</span>' +
        (priceStr ? '<span class="cc-type-btn-price">' + esc(priceStr) + '</span>' : '');
      btn.addEventListener('click', function () {
        elCaseSel.value = ct;
        elCaseSel.dispatchEvent(new Event('change'));
      });
      elCaseBtns.appendChild(btn);
    });
  }

  function updateCaseButtonStates() {
    if (!elCaseBtns) return;
    elCaseBtns.querySelectorAll('.cc-type-btn').forEach(function (btn) {
      btn.classList.toggle('cc-type-btn--active', btn.dataset.case === selectedCase);
    });
  }

  // ── Event listeners ─────────────────────────────────────────────────────────

  function attachListeners() {
    elModelBtn.addEventListener('click', openPickerPanel);

    elCaseSel.addEventListener('change', function () {
      selectedCase = this.value || null;
      updateCaseButtonStates();
      resetMockup();
      updateSteps();
      fetchStock();
      maybeGenerate();
    });

    elFileInput.addEventListener('change', function () {
      var file = this.files && this.files[0];
      if (file) handleFile(file);
    });

    elUploadZone.addEventListener('dragover', function (e) {
      e.preventDefault();
      elUploadZone.classList.add('cc-upload-zone--drag');
    });

    ['dragleave', 'dragend'].forEach(function (ev) {
      elUploadZone.addEventListener(ev, function () {
        elUploadZone.classList.remove('cc-upload-zone--drag');
      });
    });

    elUploadZone.addEventListener('drop', function (e) {
      e.preventDefault();
      elUploadZone.classList.remove('cc-upload-zone--drag');
      var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (!file) return;
      if (!file.type.match(/^image\/(png|jpeg|webp)$/)) {
        showMsg('Unsupported format. Use PNG, JPG, or WEBP.');
        return;
      }
      handleFile(file);
    });

    elAtcBtn.addEventListener('click', doAddToCart);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (elLightbox && elLightbox.classList.contains('cc-lightbox--open')) { closeLightbox(); return; }
        if (elPickerOverlay && elPickerOverlay.classList.contains('cc-picker-overlay--open')) closePickerPanel();
      }
    });

    // "?" modal buttons
    var elCaseInfoBtn   = root.querySelector('#cc-case-info-btn');
    var elUploadInfoBtn = root.querySelector('#cc-upload-info-btn');
    if (elCaseInfoBtn)   elCaseInfoBtn.addEventListener('click',   openCaseModal);
    if (elUploadInfoBtn) elUploadInfoBtn.addEventListener('click', openUploadModal);
  }

  // ── File handling ────────────────────────────────────────────────────────────

  function handleFile(file) {
    var displayName = file.name.length > 34
      ? file.name.slice(0, 32) + '\u2026'
      : file.name;
    elUploadSub.textContent = displayName;
    elUploadZone.classList.add('cc-upload-zone--has-file');
    showMsg('');

    var reader = new FileReader();
    reader.onloadend = function () {
      if (!reader.result) return;
      uploadedBase64      = reader.result.split(',')[1];
      upscaledBase64      = null; // new file — clear cached upscale
      uploadedUrl         = null;
      originalUploadedUrl = null;
      repoFileVersion++;          // invalidate any saved reposition offsets
      updateSteps();
      maybeGenerate();
    };
    reader.onerror = function () { showMsg('Could not read file. Please try again.'); };
    reader.readAsDataURL(file);
    elFileInput.value = '';
  }

  // ── Generation ───────────────────────────────────────────────────────────────

  // Crop a base64 image using a canvas. sx/sy = source origin, sw/sh = source size.
  function startCrossFadeLoop() {
    if (crossFadeLoop) { clearInterval(crossFadeLoop); crossFadeLoop = null; }
    elFrameUpload.classList.add('cc-frame-upload--visible');
    crossFadeLoop = setInterval(function() {
      elFrameUpload.classList.toggle('cc-frame-upload--visible');
    }, 3000);
  }

  function cropImageCanvas(src, sx, sy, sw, sh) {
    return new Promise(function(resolve) {
      var img = new Image();
      img.onload = function() {
        var c = document.createElement('canvas');
        c.width  = sw;
        c.height = sh;
        c.getContext('2d').drawImage(img, sx, sy, sw, sh, 0, 0, sw, sh);
        resolve(c.toDataURL('image/png'));
      };
      img.src = src;
    });
  }

  // ── Reposition UI ────────────────────────────────────────────────────────────

  function base64MimeType(b64) {
    if (b64.startsWith('/9j/'))   return 'image/jpeg';
    if (b64.startsWith('iVBOR')) return 'image/png';
    if (b64.startsWith('UklGR')) return 'image/webp';
    return 'image/png';
  }

  function ensureRepositionUI() {
    if (document.getElementById('cas-repo-overlay')) return;

    if (!document.getElementById('cas-repo-styles')) {
      var style = document.createElement('style');
      style.id = 'cas-repo-styles';
      style.textContent =
        '#cas-repo-overlay{position:fixed;inset:0;z-index:10002;display:flex;align-items:center;justify-content:center;}' +
        '#cas-repo-backdrop{position:absolute;inset:0;background:rgba(0,0,0,.78);}' +
        '#cas-repo-modal{position:relative;background:#1a1a1d;border:1px solid rgba(255,255,255,.08);border-radius:16px;padding:20px;max-width:340px;width:90%;box-sizing:border-box;box-shadow:0 24px 80px rgba(0,0,0,.85);}' +
        '#cas-repo-modal>p{margin:0 0 14px;font-family:"DM Sans",sans-serif;font-size:.68rem;letter-spacing:.12em;text-transform:uppercase;text-align:center;color:rgba(255,255,255,.38);}' +
        '#cas-repo-frame{position:relative;overflow:hidden;aspect-ratio:1264/2244;width:100%;cursor:grab;touch-action:none;user-select:none;background:#0a0a0a;border-radius:8px;border:1px solid rgba(255,255,255,.08);}' +
        '#cas-repo-frame.is-dragging{cursor:grabbing;}' +
        '#cas-repo-img{position:absolute;top:0;left:0;max-width:none;max-height:none;pointer-events:none;user-select:none;display:block;}' +
        '#cas-repo-controls{display:flex;gap:8px;margin-top:14px;}' +
        '#cas-repo-reset{flex:0 0 auto;padding:9px 14px;background:transparent;border:1px solid rgba(255,255,255,.12);border-radius:6px;cursor:pointer;font-family:"DM Sans",sans-serif;font-size:.75rem;color:rgba(255,255,255,.4);transition:border-color .2s,color .2s;}' +
        '#cas-repo-reset:hover{border-color:rgba(255,255,255,.25);color:rgba(255,255,255,.65);}' +
        '#cas-repo-cancel{flex:1;padding:9px;background:transparent;border:1px solid rgba(255,255,255,.12);border-radius:6px;cursor:pointer;font-family:"DM Sans",sans-serif;font-size:.75rem;color:rgba(255,255,255,.45);transition:border-color .2s,color .2s;}' +
        '#cas-repo-cancel:hover{border-color:rgba(255,255,255,.25);color:rgba(255,255,255,.65);}' +
        '#cas-repo-confirm{flex:1;padding:9px;background:rgba(201,168,76,.1);border:1px solid rgba(201,168,76,.45);border-radius:6px;cursor:pointer;font-family:"DM Sans",sans-serif;font-size:.72rem;font-weight:600;letter-spacing:.07em;text-transform:uppercase;color:#c9a84c;transition:background .2s,border-color .2s;}' +
        '#cas-repo-confirm:hover{background:rgba(201,168,76,.18);border-color:rgba(201,168,76,.75);}';
      document.head.appendChild(style);
    }

    var overlay = document.createElement('div');
    overlay.id = 'cas-repo-overlay';
    overlay.style.display = 'none';
    overlay.innerHTML =
      '<div id="cas-repo-backdrop"></div>' +
      '<div id="cas-repo-modal">' +
        '<p>Drag to reposition your photo</p>' +
        '<div id="cas-repo-frame"><img id="cas-repo-img" alt="" draggable="false"></div>' +
        '<div id="cas-repo-controls">' +
          '<button type="button" id="cas-repo-reset">Reset</button>' +
          '<button type="button" id="cas-repo-cancel">Cancel</button>' +
          '<button type="button" id="cas-repo-confirm">Regenerate</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);
  }

  function openRepositionUI(displaySrc, onConfirm) {
    ensureRepositionUI();
    repoOnConfirm = onConfirm;

    var overlay = document.getElementById('cas-repo-overlay');
    var frame   = document.getElementById('cas-repo-frame');
    var img     = document.getElementById('cas-repo-img');

    overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    img.onload = function() {
      repoFrameW     = frame.clientWidth;
      repoFrameH     = frame.clientHeight;
      var scaleX     = repoFrameW / img.naturalWidth;
      var scaleY     = repoFrameH / img.naturalHeight;
      repoCoverScale = Math.max(scaleX, scaleY);
      var dW = img.naturalWidth  * repoCoverScale;
      var dH = img.naturalHeight * repoCoverScale;
      img.style.width  = dW + 'px';
      img.style.height = dH + 'px';
      // Restore last position for this file, otherwise center
      if (repoPersistVersion === repoFileVersion && repoPersistOffsetX !== null) {
        var c = clampRepoOffset(repoPersistOffsetX, repoPersistOffsetY);
        repoOffsetX = c.x; repoOffsetY = c.y;
      } else {
        repoOffsetX = -(dW - repoFrameW) / 2;
        repoOffsetY = -(dH - repoFrameH) / 2;
      }
      setRepoImageTransform();
      frame.addEventListener('mousedown', repoMouseDown);
      frame.addEventListener('touchstart', repoTouchStart, { passive: true });
    };
    img.src = displaySrc;

    document.getElementById('cas-repo-reset').onclick   = resetRepoPosition;
    document.getElementById('cas-repo-cancel').onclick  = closeRepositionUI;
    document.getElementById('cas-repo-confirm').onclick = confirmReposition;
    document.getElementById('cas-repo-backdrop').onclick = closeRepositionUI;
  }

  function closeRepositionUI() {
    var overlay = document.getElementById('cas-repo-overlay');
    var frame   = document.getElementById('cas-repo-frame');
    if (overlay) overlay.style.display = 'none';
    document.body.style.overflow = '';
    if (frame) {
      frame.removeEventListener('mousedown',  repoMouseDown);
      frame.removeEventListener('touchstart', repoTouchStart);
    }
    document.removeEventListener('mousemove', repoMouseMove);
    document.removeEventListener('mouseup',   repoMouseUp);
    document.removeEventListener('touchmove', repoTouchMove);
    document.removeEventListener('touchend',  repoTouchEnd);
    repoDragging = false;
  }

  function setRepoImageTransform() {
    var img = document.getElementById('cas-repo-img');
    if (img) img.style.transform = 'translate(' + repoOffsetX + 'px,' + repoOffsetY + 'px)';
  }

  function clampRepoOffset(x, y) {
    var img = document.getElementById('cas-repo-img');
    var dW  = img ? parseFloat(img.style.width)  || 0 : 0;
    var dH  = img ? parseFloat(img.style.height) || 0 : 0;
    return {
      x: Math.max(-(dW - repoFrameW), Math.min(0, x)),
      y: Math.max(-(dH - repoFrameH), Math.min(0, y)),
    };
  }

  function resetRepoPosition() {
    var img = document.getElementById('cas-repo-img');
    if (!img) return;
    var dW = parseFloat(img.style.width)  || 0;
    var dH = parseFloat(img.style.height) || 0;
    repoOffsetX = -(dW - repoFrameW) / 2;
    repoOffsetY = -(dH - repoFrameH) / 2;
    repoPersistOffsetX = null; // clear saved position so next open starts centered
    repoPersistOffsetY = null;
    repoPersistVersion = -1;
    setRepoImageTransform();
  }

  function repoMouseDown(e) {
    repoDragging   = true;
    repoDragStartX = e.clientX - repoOffsetX;
    repoDragStartY = e.clientY - repoOffsetY;
    e.currentTarget.classList.add('is-dragging');
    document.addEventListener('mousemove', repoMouseMove);
    document.addEventListener('mouseup',   repoMouseUp);
  }

  function repoMouseMove(e) {
    if (!repoDragging) return;
    var c = clampRepoOffset(e.clientX - repoDragStartX, e.clientY - repoDragStartY);
    repoOffsetX = c.x; repoOffsetY = c.y;
    setRepoImageTransform();
  }

  function repoMouseUp() {
    repoDragging = false;
    var frame = document.getElementById('cas-repo-frame');
    if (frame) frame.classList.remove('is-dragging');
    document.removeEventListener('mousemove', repoMouseMove);
    document.removeEventListener('mouseup',   repoMouseUp);
    repoPersistOffsetX = repoOffsetX; // remember position for next open
    repoPersistOffsetY = repoOffsetY;
    repoPersistVersion = repoFileVersion;
  }

  function repoTouchStart(e) {
    if (e.touches.length !== 1) return;
    repoDragging   = true;
    repoDragStartX = e.touches[0].clientX - repoOffsetX;
    repoDragStartY = e.touches[0].clientY - repoOffsetY;
    document.addEventListener('touchmove', repoTouchMove, { passive: false });
    document.addEventListener('touchend',  repoTouchEnd);
  }

  function repoTouchMove(e) {
    if (!repoDragging || e.touches.length !== 1) return;
    e.preventDefault();
    var c = clampRepoOffset(e.touches[0].clientX - repoDragStartX, e.touches[0].clientY - repoDragStartY);
    repoOffsetX = c.x; repoOffsetY = c.y;
    setRepoImageTransform();
  }

  function repoTouchEnd() {
    repoDragging = false;
    document.removeEventListener('touchmove', repoTouchMove);
    document.removeEventListener('touchend',  repoTouchEnd);
    repoPersistOffsetX = repoOffsetX; // remember position for next open
    repoPersistOffsetY = repoOffsetY;
    repoPersistVersion = repoFileVersion;
  }

  function confirmReposition() {
    if (typeof repoOnConfirm !== 'function') { closeRepositionUI(); return; }
    var ox = repoOffsetX;
    var oy = repoOffsetY;
    closeRepositionUI();
    repoOnConfirm(ox, oy);
  }

  // Crop src (URL or data URL) to PRINT_W×PRINT_H using current repo frame/offset state.
  // Uses the Tigris URL (already upscaled) when available so quality is preserved.
  // Falls back to the original base64 if the URL can't be read due to CORS.
  function cropToBase64(src, fallbackBase64, ox, oy) {
    function docrop(imgSrc) {
      return new Promise(function(resolve, reject) {
        var img = new Image();
        if (imgSrc.indexOf('http') === 0) img.crossOrigin = 'anonymous';
        img.onload = function() {
          var scale = Math.max(repoFrameW / img.naturalWidth, repoFrameH / img.naturalHeight);
          var srcX = -ox / scale;
          var srcY = -oy / scale;
          var srcW = repoFrameW / scale;
          var srcH = repoFrameH / scale;
          try {
            var c = document.createElement('canvas');
            c.width  = PRINT_W;
            c.height = PRINT_H;
            c.getContext('2d').drawImage(img, srcX, srcY, srcW, srcH, 0, 0, PRINT_W, PRINT_H);
            resolve(c.toDataURL('image/jpeg', 0.92).split(',')[1]);
          } catch (e) {
            reject(e); // CORS taint
          }
        };
        img.onerror = reject;
        img.src = imgSrc;
      });
    }
    return docrop(src).catch(function() {
      // Tigris CORS blocked — fall back to original local base64
      return docrop('data:' + base64MimeType(fallbackBase64) + ';base64,' + fallbackBase64);
    });
  }

  function maybeGenerate() {
    if (!selectedModel || !selectedCase || !uploadedBase64) return;
    clearTimeout(genTimer);
    genTimer = setTimeout(doGenerate, DEBOUNCE_MS);
  }

  async function doGenerate(overrideBase64) {
    if (isGenerating) return;
    isGenerating = true;
    mockupReady  = false;

    // Reset any previously shown mockup so before/after animation resumes
    if (elFrameMockup) {
      elFrameMockup.classList.remove('cc-frame-mockup--visible');
      elFrameMockup.src = '';
    }
    if (elPhoneFrame) elPhoneFrame.classList.remove('cc-phone-frame--static');
    if (elUpscaleBadge) elUpscaleBadge.classList.remove('cc-upscale-badge--visible');
    if (elRetryBtn) elRetryBtn.style.display = 'none';

    updateSteps();
    setSpinner(true);
    showMsg('Generating your preview — this can take 10–20 seconds if your image needs upscaling…');

    try {
      var resp = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          model:               selectedModel,
          caset:               selectedCase,
          imageBase64:         overrideBase64 || uploadedBase64,
          returnUpscaledBase64: !upscaledBase64, // only needed on first gen
        }),
      });
      if (!resp.ok) throw new Error('HTTP ' + resp.status);

      var result = await resp.json();
      if (!result.success || !result.mockup) throw new Error(result.error || 'No mockup returned');
      if (result.upscaleFailed) {
        showMsg('Image upscaling failed. Try again, or use a higher-resolution photo.', true);
        if (elRetryBtn) elRetryBtn.style.display = '';
        return;
      }

      var rawSrc = 'data:image/png;base64,' + result.mockup;
      var enableCrop = root.dataset.enableCrop !== 'false';
      var src = enableCrop ? await cropImageCanvas(rawSrc, 490, 96, 820, 1609) : rawSrc;

      // Stop before/after animation; preload cropped mockup (base64 is instant)
      if (elPhoneFrame) elPhoneFrame.classList.add('cc-phone-frame--static');
      elFrameMockup.src = src;
      elFrameMockup.style.objectFit = enableCrop ? 'contain' : 'cover';
      elFrameMockup.removeAttribute('aria-hidden');

      // Show mockup immediately
      elFrameMockup.classList.add('cc-frame-mockup--visible');

      if (elFrameUpload && result.uploadUrl) {
        // Load upload photo in background; start alternating loop once ready
        elFrameUpload.onload = function() { startCrossFadeLoop(); };
        elFrameUpload.src = result.uploadUrl;
      }

      uploadedUrl = result.uploadUrl || null;
      if (!originalUploadedUrl) originalUploadedUrl = uploadedUrl;
      if (result.upscaledBase64 && !upscaledBase64) upscaledBase64 = result.upscaledBase64;
      mockupReady = true;
      if (elRepoBtn) elRepoBtn.style.display = '';
      if (elPhoneFrame) elPhoneFrame.classList.add('cc-phone-frame--zoomable');

    } catch (err) {
      showMsg('Could not generate preview. Please try again.');
    } finally {
      isGenerating = false;
      setSpinner(false);
      if (mockupReady) showMsg('');
      updateSteps();
      updateAtcBtn();
    }
  }

  function openLightbox() {
    if (!elLightbox || !elFrameMockup || !elFrameMockup.src) return;
    elLightboxImg.src = elFrameMockup.src;
    elLightbox.classList.add('cc-lightbox--open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!elLightbox) return;
    elLightbox.classList.remove('cc-lightbox--open');
    document.body.style.overflow = '';
  }

  function resetMockup() {
    mockupReady = false;
    uploadedUrl = null;
    clearTimeout(genTimer);
    if (isGenerating) return; // let the in-flight request finish, doGenerate finally handles cleanup
    if (elFrameMockup) {
      elFrameMockup.classList.remove('cc-frame-mockup--visible');
      elFrameMockup.src = '';
    }
    if (crossFadeLoop) { clearInterval(crossFadeLoop); crossFadeLoop = null; }
    if (elFrameUpload) {
      elFrameUpload.onload = null;
      elFrameUpload.classList.remove('cc-frame-upload--visible');
      elFrameUpload.src = '';
    }
    if (elPhoneFrame) elPhoneFrame.classList.remove('cc-phone-frame--static', 'cc-phone-frame--zoomable');
    if (elUpscaleBadge) elUpscaleBadge.classList.remove('cc-upscale-badge--visible');
    if (elRepoBtn) elRepoBtn.style.display = 'none';
    setSpinner(false);
    showMsg('');
  }

  // ── Stock indicator ──────────────────────────────────────────────────────────

  var CC_STOCK_LOW_THRESHOLD = 10;

  function ccFormatRestockDate(iso) {
    if (!iso) return null;
    var d = new Date(iso);
    if (isNaN(d.getTime())) return null;
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
  }

  function fetchStock() {
    if (!elStock) return;
    if (!selectedModel || !selectedCase) { elStock.hidden = true; _ccStockLocked = false; updateAtcBtn(); return; }
    var productRef = caseData[selectedCase] && caseData[selectedCase][selectedModel];
    if (!productRef) { elStock.hidden = true; _ccStockLocked = false; updateAtcBtn(); return; }

    if (_ccStockCache[productRef]) { renderStock(productRef, _ccStockCache[productRef]); return; }

    elStock.hidden = true;
    fetch('/apps/mockup/stock?ref=' + encodeURIComponent(productRef))
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(data) {
        if (!data || data.error) return;
        _ccStockCache[productRef] = data;
        var currentRef = caseData[selectedCase] && caseData[selectedCase][selectedModel];
        if (currentRef === productRef) renderStock(productRef, data);
      })
      .catch(function() {});
  }

  function renderStock(productRef, data) {
    if (!elStock) return;
    var qty = data.quantity;
    var canBackorder = data.canBackorder;

    elStock.className = 'cc-stock';

    if (qty >= CC_STOCK_LOW_THRESHOLD) {
      elStock.hidden = true;
      _ccStockLocked = false;
      updateAtcBtn();
      return;
    }

    var ct = selectedCase || '';
    var forCt = ct ? ' for ' + ct : '';
    var text;

    if (qty === 0 && !canBackorder) {
      text = 'Out of stock' + forCt;
      elStock.classList.add('cc-stock--out');
      _ccStockLocked = true;
    } else if (qty === 0) {
      var restockDate = ccFormatRestockDate(data.expectedAvailableDate);
      text = 'Out of stock' + forCt + (restockDate ? ' – back ' + restockDate + ' – ships when restocked' : ' – ships when restocked');
      elStock.classList.add('cc-stock--low');
      _ccStockLocked = false;
    } else {
      text = 'Only ' + qty + ' left for ' + ct;
      elStock.classList.add('cc-stock--low');
      _ccStockLocked = false;
    }

    elStock.innerHTML = '<span class="cc-stock-dot"></span><span>' + esc(text) + '</span>';
    elStock.hidden = false;
    updateAtcBtn();
  }

  // ── Variants fetch + ATC ─────────────────────────────────────────────────────

  function fetchVariants() {
    fetch(CPC_VARIANTS_URL)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cpcVariants = data.variants || [];
        // Build price map: canonical case type name => lowest price in cents
        // Also derive case type display order from variant order in Shopify admin
        variantPriceByCase = {};
        var seenOrder = [];
        cpcVariants.forEach(function (v) {
          var titleNorm = norm(v.title || '').split('|')[0].trim();
          var ct = null;
          for (var k = 0; k < CASE_TYPE_ORDER.length; k++) {
            if (norm(CASE_TYPE_ORDER[k]) === titleNorm) { ct = CASE_TYPE_ORDER[k]; break; }
          }
          // If Shopify variant name doesn't match our internal key, try alias map
          if (!ct && VARIANT_NAME_MAP[titleNorm]) ct = VARIANT_NAME_MAP[titleNorm];
          if (!ct) return;
          if (seenOrder.indexOf(ct) === -1) seenOrder.push(ct);
          if (variantPriceByCase[ct] === undefined || v.price < variantPriceByCase[ct]) {
            variantPriceByCase[ct] = v.price;
          }
        });
        if (seenOrder.length > 0) caseTypeOrder = seenOrder;
        var prices = Object.keys(variantPriceByCase).map(function (k) { return variantPriceByCase[k]; });
        basePrice = prices.length ? Math.min.apply(null, prices) : null;
        // Refresh case select if model already chosen (adds prices retroactively)
        if (selectedModel) buildCaseButtons(selectedModel);
        updateAtcBtn();
      })
      .catch(function () { cpcVariants = []; });
  }

  function findVariant() {
    if (!cpcVariants || !cpcVariants.length) return null;
    var c = norm(selectedCase);
    for (var i = 0; i < cpcVariants.length; i++) {
      var v = cpcVariants[i];
      // CPC is single-option: variant titles are "Soft Case | Matte", "Eco Case | Matte", etc.
      // Match by the part before the " | " separator.
      var titlePart = norm(v.title || '').split('|')[0].trim();
      var opt1Part  = norm(v.option1 || '').split('|')[0].trim();
      // Also match via alias (e.g. selectedCase='Hard Case', variant title='Snap Case')
      var cAlias = VARIANT_NAME_MAP[titlePart] ? norm(VARIANT_NAME_MAP[titlePart]) : null;
      if (titlePart === c || opt1Part === c || cAlias === c) return v;
    }
    return null;
  }

  async function doAddToCart() {
    if (!mockupReady || isGenerating || atcBusy) return;
    if (!uploadedUrl) { showMsg('Mockup upload is still in progress. Please wait.'); return; }

    var variant = findVariant();
    if (!variant) {
      if (!cpcVariants) {
        showMsg('Still loading product data. Please try again in a moment.');
      } else {
        showMsg('Could not find a variant for ' + selectedModel + ' / ' + selectedCase + '. Please refresh.');
      }
      return;
    }

    atcBusy = true;
    var label = elAtcBtn.dataset.label || elAtcBtn.textContent;
    elAtcBtn.disabled = true;
    elAtcBtn.textContent = 'Adding\u2026';
    showMsg('');

    try {
      var resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variant.id, quantity: 1, properties: { 'Phone Model': selectedModel, 'Design URL': uploadedUrl } }],
        }),
      });

      if (!resp.ok) {
        var errData = await resp.json().catch(function () { return {}; });
        throw new Error(errData.description || 'Add to cart failed (HTTP ' + resp.status + ')');
      }

      await resp.json();
      elAtcBtn.textContent = 'Added!';

      // Fetch updated cart and dispatch the event Horizon uses to re-render the drawer
      var updatedCart = await fetch('/cart.js').then(function (r) { return r.json(); });
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { data: updatedCart },
      }));

      // Open the drawer after Horizon has processed the cart:update event
      setTimeout(function () {
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.open = true;
        } else {
          var trigger = (
            document.querySelector('[data-cart-drawer-trigger]') ||
            document.querySelector("[aria-controls='cart-drawer']") ||
            document.querySelector('.header__icon--cart')
          );
          if (trigger) trigger.click();
        }
      }, 400);

      setTimeout(function () { if (!atcBusy) updateAtcBtn(); }, 2500);

    } catch (err) {
      showMsg(err.message || 'Could not add to cart. Please try again.');
      elAtcBtn.textContent = label;
      elAtcBtn.disabled = false;
    } finally {
      atcBusy = false;
    }
  }

  // ── UI helpers ───────────────────────────────────────────────────────────────

  function updateSteps() {
    if (!elSteps) return;
    var steps = elSteps.querySelectorAll('.cc-step');
    steps.forEach(function (el) {
      var s = el.dataset.step;
      var active = false;
      if (s === 'model') active = !!selectedModel;
      if (s === 'case')  active = !!selectedCase;
      if (s === 'photo') active = !!uploadedBase64;
      if (s === 'ready') active = mockupReady;
      el.classList.toggle('cc-step--active', active);
    });
    updateAtcBtn();
  }

  // ── Modals ───────────────────────────────────────────────────────────────────

  function esc(s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;'); }

  var PRO_ICON = '<svg class="cc-info-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#5a9e6f" stroke-width="2.5" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';
  var CON_ICON = '<svg class="cc-info-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#c4903a" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 8v4m0 4h.01"/></svg>';
  var CLOSE_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>';

  function renderCaseCardContent(ct) {
    var info = CASE_INFO[ct];
    if (!info) return '';
    var h = '';
    if (info.img) h += '<img class="cc-card-img" src="' + esc(info.img) + '" alt="' + esc(ct) + '" loading="lazy">';
    h += '<div class="cc-card-body">';
    h += '<div class="cc-card-name-row">';
    h += '<p class="cc-card-name">' + esc(ct) + '</p>';
    h += '</div>';
    if (info.finish) h += '<span class="cc-card-finish">' + esc(info.finish) + '</span>';
    h += '<ul class="cc-info-list">';
    info.pros.forEach(function (p) { h += '<li class="cc-info-item">' + PRO_ICON + '<span>' + esc(p) + '</span></li>'; });
    info.cons.forEach(function (c) { h += '<li class="cc-info-item cc-info-item--con">' + CON_ICON + '<span>' + esc(c) + '</span></li>'; });
    h += '</ul></div>';
    return h;
  }

  function renderCaseCards() {
    var html = '';
    CASE_GROUPS.forEach(function (group) {
      var chips = group.chips;

      // Filter to variants available for the selected model
      var variants = group.variants.filter(function (v) {
        if (!CASE_INFO[v]) return false;
        if (selectedModel && caseData[v] && !caseData[v][selectedModel]) return false;
        return true;
      });
      var activeChips = group.variants.reduce(function (acc, v, i) {
        if (variants.indexOf(v) !== -1) acc.push(chips ? chips[i] || v : v);
        return acc;
      }, []);

      if (variants.length === 0) return;

      var isGrouped = variants.length > 1 && chips;
      if (!isGrouped) {
        var soloInfo = CASE_INFO[variants[0]];
        if (!soloInfo || soloInfo.modal === false) return;
      }

      var activeCt = variants[0];
      if (selectedCase && variants.indexOf(selectedCase) !== -1) activeCt = selectedCase;

      var isSelected = variants.indexOf(selectedCase) !== -1;
      var cls = 'cc-card' + (isSelected ? ' cc-card--selected' : '') + (isGrouped ? ' cc-card--grouped' : '');
      html += '<div class="' + cls + '" data-ct="' + esc(activeCt) + '" role="button" tabindex="0">';

      if (isGrouped) {
        html += '<div class="cc-chip-row">';
        variants.forEach(function (v, i) {
          var label = activeChips[i] || v;
          html += '<button class="cc-chip' + (v === activeCt ? ' cc-chip--active' : '') + '" data-variant="' + esc(v) + '" tabindex="-1">' + esc(label) + '</button>';
        });
        html += '</div><div class="cc-card-inner">';
      }

      html += renderCaseCardContent(activeCt);

      if (isGrouped) html += '</div>';
      html += '</div>';
    });
    return html;
  }

  function buildModals() {
    // Case compare modal
    var caseOverlay = document.createElement('div');
    caseOverlay.id = 'cc-info-overlay';
    caseOverlay.className = 'cc-info-overlay';
    caseOverlay.setAttribute('role', 'dialog');
    caseOverlay.setAttribute('aria-modal', 'true');
    caseOverlay.setAttribute('aria-label', 'Compare case types');
    caseOverlay.innerHTML =
      '<div class="cc-info-panel">' +
        '<div class="cc-info-panel-header">' +
          '<p class="cc-info-panel-title">Compare case types</p>' +
          '<button type="button" class="cc-info-close-btn" id="cc-info-close" aria-label="Close">' + CLOSE_SVG + '</button>' +
        '</div>' +
        '<div class="cc-info-cards" id="cc-info-cards"></div>' +
      '</div>';
    document.body.appendChild(caseOverlay);

    // Upload guide modal
    var uploadOverlay = document.createElement('div');
    uploadOverlay.id = 'cc-upload-info-overlay';
    uploadOverlay.className = 'cc-info-overlay';
    uploadOverlay.setAttribute('role', 'dialog');
    uploadOverlay.setAttribute('aria-modal', 'true');
    uploadOverlay.setAttribute('aria-label', 'Image upload guide');
    uploadOverlay.innerHTML =
      '<div class="cc-info-panel">' +
        '<div class="cc-info-panel-header">' +
          '<p class="cc-info-panel-title">Image upload guide</p>' +
          '<button type="button" class="cc-info-close-btn" id="cc-upload-info-close" aria-label="Close">' + CLOSE_SVG + '</button>' +
        '</div>' +
        '<div class="cc-upload-info-body">' +
          '<div class="cc-upload-info-section">' +
            '<p class="cc-upload-info-heading">Supported formats</p>' +
            '<p class="cc-upload-info-text">PNG, JPG, WEBP</p>' +
          '</div>' +
          '<div class="cc-upload-info-section">' +
            '<p class="cc-upload-info-heading">Resolution</p>' +
            '<p class="cc-upload-info-text">Don\'t worry about resolution. We upscale your image to ensure a high print quality.</p>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(uploadOverlay);

    // Shared close behaviour
    function closeAll() {
      caseOverlay.classList.remove('cc-info-overlay--open');
      uploadOverlay.classList.remove('cc-info-overlay--open');
      document.body.style.overflow = '';
    }

    document.getElementById('cc-info-close').addEventListener('click', closeAll);
    document.getElementById('cc-upload-info-close').addEventListener('click', closeAll);

    [caseOverlay, uploadOverlay].forEach(function (ov) {
      ov.addEventListener('click', function (e) { if (e.target === ov) closeAll(); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    // Chip click: switch active variant within grouped card
    // Card click: select case type and close
    document.getElementById('cc-info-cards').addEventListener('click', function (e) {
      var chip = e.target.closest('.cc-chip');
      if (chip) {
        var card = chip.closest('.cc-card');
        if (!card) return;
        var newCt = chip.dataset.variant;
        if (!newCt || !CASE_INFO[newCt]) return;
        card.querySelectorAll('.cc-chip').forEach(function (c) { c.classList.remove('cc-chip--active'); });
        chip.classList.add('cc-chip--active');
        card.dataset.ct = newCt;
        var inner = card.querySelector('.cc-card-inner');
        if (inner) inner.innerHTML = renderCaseCardContent(newCt);
        return;
      }

      var card = e.target.closest('[data-ct]');
      if (!card) return;
      var ct = card.getAttribute('data-ct');
      selectedCase = ct;
      elCaseSel.value = ct;
      elCaseSel.dispatchEvent(new Event('change', { bubbles: true }));
      closeAll();
    });
  }

  function openCaseModal() {
    var cards = document.getElementById('cc-info-cards');
    if (!cards) return;
    cards.innerHTML = renderCaseCards();
    document.getElementById('cc-info-overlay').classList.add('cc-info-overlay--open');
    document.body.style.overflow = 'hidden';
  }

  function openUploadModal() {
    var ov = document.getElementById('cc-upload-info-overlay');
    if (!ov) return;
    ov.classList.add('cc-info-overlay--open');
    document.body.style.overflow = 'hidden';
  }

  function getAtcLabel() {
    var base  = elAtcBtn.dataset.label || 'Buy this case';
    var price = (selectedCase && variantPriceByCase[selectedCase] !== undefined)
      ? variantPriceByCase[selectedCase]
      : basePrice;
    return price !== null ? base + '  \u00b7  ' + formatMoney(price) : base;
  }

  function updateAtcBtn() {
    if (!elAtcBtn) return;
    var ready = mockupReady && !!uploadedUrl && !isGenerating && !atcBusy && !_ccStockLocked;
    elAtcBtn.disabled = !ready;
    if (!atcBusy) {
      elAtcBtn.textContent = (_ccStockLocked && mockupReady) ? 'Out of stock' : getAtcLabel();
    }
    var tip = '';
    if (!_ccStockLocked) {
      if (!selectedModel)      tip = 'Select a phone model';
      else if (!selectedCase)  tip = 'Select a case type';
      else if (!uploadedBase64) tip = 'Upload your photo';
      else if (isGenerating)   tip = 'Generating your preview\u2026';
    }
    elAtcBtn.dataset.tip = tip;
  }

  function setSpinner(visible) {
    if (!elFrameSpinner) return;
    elFrameSpinner.setAttribute('aria-hidden', visible ? 'false' : 'true');
    elFrameSpinner.classList.toggle('cc-frame-spinner--visible', visible);
  }

  function showMsg(text, isError) {
    if (!elMsg) return;
    elMsg.textContent = text;
    elMsg.classList.toggle('cc-msg--error', !!isError);
  }

  // ── Init ─────────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

})();
